"use client";

import { LazyMotion, domAnimation } from "framer-motion";
import WhyWe from "./WhyWe";
import NoteFromFounder from "./NoteFromFounder";
import OurMission from "./OurMission";

const IntroSections = () => {
    return (
        <>
            <WhyWe />
            <LazyMotion features={domAnimation} strict>
                <OurMission />
                <NoteFromFounder />
            </LazyMotion>
        </>
    );
};

export default IntroSections;
